'use client';

import { c as _c } from "react/compiler-runtime";
import { useSession } from '@lib/auth/client';
import { DesktopSearchNav } from '@layouts/public-layout/desktop-search-nav';
import { Search } from '../../_components/search';
import { SearchPageShell } from '../../_components/search-page-shell';
export function SearchPageClient() {
  const $ = _c(5);
  const {
    data: session
  } = useSession();
  let t0;
  if ($[0] !== session) {
    t0 = <DesktopSearchNav session={session} />;
    $[0] = session;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Search />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <SearchPageShell>{t0}{t1}</SearchPageShell>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}